import { LinearProgress, withStyles } from '@material-ui/core'
import i18n from 'i18next'
import { FC, Fragment } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { updateStatus } from '../../../actions/apartments'
import { navigate } from '../../../actions/routes'
import { deleteShowing } from '../../../actions/showings'
import { Navigate, UpdateStatus } from '../../../actions/types'
import Container from '../../../components/Container'
import {
  selectApartmentById,
  selectApartmentFilesByApartmentId
} from '../../../selectors/apartments'
import { selectApplications } from '../../../selectors/applications'
import {
  selectContentIdFromPathname,
  selectUserIdFromPathname
} from '../../../selectors/router'
import { selectFutureShowingsByApartmentId } from '../../../selectors/showings'
import { selectIsAdminUser, selectUserByUserId } from '../../../selectors/users'
import { DeleteShowingArgs } from '../../../services/showings'
import { BucketObject } from '../../../services/storage/types'
import { MuiClasses } from '../../../types'
import { Apartment } from '../../../types/apartments'
import { ReservedShowing, Showing } from '../../../types/showings'
import { IndexedApplications, StateInterface } from '../../../types/states'
import { User } from '../../../types/users'
// import Suggest from '../Stepper/Steps/Suggest'
import ApartmentInformation from './ApartmentInformation'

const styles = () => ({
  grow: {
    flexGrow: 1
  },
  toolbar: {
    float: 'right' as const
  }
})

interface ApartmentOverviewProps {
  classes: MuiClasses
  apartment: Apartment | undefined
  user: User | undefined
  futureShowings: Showing[]
  files: BucketObject[]
  t: i18n.TFunction
  isAdmin: boolean
  isApartmentsLoading: boolean
  reservations: ReservedShowing[] | undefined
  navigateAction: (path: string) => void
  navigate: Navigate
  applications: IndexedApplications
  dispatchDeleteShowing: (args: DeleteShowingArgs) => void
  updateStatus: UpdateStatus
}

const ApartmentOverview: FC<ApartmentOverviewProps> = ({
  t,
  isAdmin,
  apartment,
  user,
  futureShowings,
  files,
  applications,
  navigate,
  dispatchDeleteShowing,
  updateStatus
}) => {
  if (!apartment) {
    return <LinearProgress />
  }
  const apartmentInformationProps = {
    t,
    files,
    apartment,
    user,
    applications,
    futureShowings,
    isAdmin,
    navigate,
    updateStatus,
    deleteShowing: dispatchDeleteShowing
  }
  return (
    <Fragment>
      <Container>
        {apartment && <ApartmentInformation {...apartmentInformationProps} />}
      </Container>
    </Fragment>
  )
}

const mapStateToProps = (state: StateInterface) => {
  const apartmentId = selectContentIdFromPathname(state)
  const userId = selectUserIdFromPathname(state)
  return {
    isAdmin: selectIsAdminUser(state),
    apartment: apartmentId
      ? selectApartmentById(apartmentId)(state)
      : undefined,
    user: userId ? selectUserByUserId(userId)(state) : undefined,
    applications: selectApplications(state),
    futureShowings: apartmentId
      ? selectFutureShowingsByApartmentId(apartmentId)(state)
      : [],
    files: apartmentId
      ? selectApartmentFilesByApartmentId(apartmentId)(state)
      : []
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  navigate: (path: string) => dispatch(navigate(path)),
  dispatchDeleteShowing: (args: DeleteShowingArgs) =>
    dispatch(deleteShowing(args)),
  updateStatus: (status: string) => dispatch(updateStatus(status))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(ApartmentOverview as any)))
